import { render, staticRenderFns } from "./tap4.vue?vue&type=template&id=b25544ea&scoped=true&"
import script from "./tap4.vue?vue&type=script&lang=js&"
export * from "./tap4.vue?vue&type=script&lang=js&"
import style0 from "./tap4.vue?vue&type=style&index=0&id=b25544ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25544ea",
  null
  
)

export default component.exports